import React from "react";
import PropTypes from "prop-types";

import StripePortalLink from "frontend/components/core/StripePortalLink";
import { Section, Title, SpacedBlock } from "./styles";

import { apolloClient } from "js/apollo/apollo-client";
import { STRIPE_LINK_TEXT } from "./data";

const StripePortalElement = ({ organizationId = null }) => (
    <Section>
        <Title>Manage Billing Information</Title>
        <SpacedBlock>
            <StripePortalLink
                client={apolloClient}
                organizationId={organizationId}
                showTooltip
            >
                {STRIPE_LINK_TEXT}
            </StripePortalLink>
        </SpacedBlock>
    </Section>
);

StripePortalElement.propTypes = {
    organizationId: PropTypes.number,
};

export default StripePortalElement;
